export enum SnCameraManagedType {
  BOSCH = 'bosch',
}
